module.exports = __webpack_public_path__ + "img/MingHe.79320ea4.png";